import { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  pending: boolean;
  pendingLabel?: ReactNode;
  children: ReactNode;
}

// Submit button with a spinner+label while pending. Disables itself when pending.
export function SubmitButton({
  pending,
  pendingLabel = 'Saving…',
  children,
  disabled,
  type = 'submit',
  className = 'btn btn-primary',
  ...rest
}: Props) {
  return (
    <button type={type} className={className} disabled={disabled || pending} {...rest}>
      {pending
        ? <><i className="fas fa-spinner fa-spin" aria-hidden="true" /> {pendingLabel}</>
        : children}
    </button>
  );
}
